var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoubleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#275AE6",
    d: "M19.508 8.811L11.188.492a1.68 1.68 0 10-2.376 2.377l7.13 7.13-7.13 7.13a1.682 1.682 0 002.377 2.377l8.319-8.32a1.68 1.68 0 000-2.375zM9.505 8.308L2.9 1.346a1.64 1.64 0 00-2.402 0 1.858 1.858 0 000 2.532l5.404 5.695L.498 15.27a1.857 1.857 0 000 2.531 1.638 1.638 0 002.402 0l6.605-6.961a1.859 1.859 0 000-2.531z"
  })));
}

export default SvgDoubleArrow;